<script setup lang="ts">
  import './MpfButton.scss';
  import type { MpfButtonProps } from './MpfButton.props';
  import { mpfButtonDefaults } from './MpfButton.props';
  import { computed, ref } from 'vue';

  const props = withDefaults(defineProps<MpfButtonProps>(), mpfButtonDefaults);

  const clickLocked = ref(false);

  const emit = defineEmits<{
    (e: 'click', event: MouseEvent): void;
  }>();

  const buttonClasses = computed(() => [
    'mpf-button',
    props.variant && `mpf-button--${props.variant}`,
    props.disabled && 'mpf-button--disabled',
  ]);

  const isDisabled = computed(() => props.disabled || clickLocked.value);

  function handleClick(event: MouseEvent) {
    if (props.disabled) {
      event.preventDefault();
      return;
    }

    emit('click', event);

    // Activate lock if enabled
    if (props.preventDoubleClick) {
      clickLocked.value = true;
      setTimeout(() => {
        clickLocked.value = false;
      }, 400);
    }
  }
</script>
<template>
  <button type="button" :class="buttonClasses" :disabled="isDisabled" @click="handleClick">
    <span>{{ label }}</span>
  </button>
</template>
